module.exports = __webpack_public_path__ + "assets/img/2b05ede493cb5abd17f0a1e7ef2d2d13.png";